/* Shopify section rendering for both Fake Tattoos collection grids. */
(function () {
  'use strict';

  if (window.__clyroCollectionFiltersVersion) return;
  window.__clyroCollectionFiltersVersion = '2.0';

  var requests = new Map();
  var priceTimers = new WeakMap();

  function sectionFor(node) {
    return node && node.closest ? node.closest('[data-collection-section]') : null;
  }

  function formDestination(form) {
    var destination = new URL(form.action, window.location.href);
    var params = new URLSearchParams(new FormData(form));
    // Empty price fields must not become active price filters.
    Array.from(params.keys()).forEach(function (key) {
      if (params.getAll(key).every(function (value) { return !value.trim(); })) params.delete(key);
    });
    params.delete('page');
    destination.search = params.toString();
    return destination;
  }

  function rememberFocus(target) {
    if (!target || !target.name) return null;
    return { name: target.name, value: target.value, type: target.type };
  }

  function restoreFocus(section, focus) {
    if (!focus) return;
    var form = section.querySelector('[data-collection-filter-form]');
    if (!form) return;
    var controls = form.elements[focus.name];
    var choices = controls && typeof controls.length === 'number' && !controls.tagName ?
      Array.from(controls) : controls ? [controls] : [];
    var match = choices.find(function (input) {
      return input.type === focus.type && (focus.type !== 'checkbox' || input.value === focus.value);
    });
    if (match && !match.disabled) match.focus({ preventScroll: true });
  }

  function render(section, destination, options) {
    if (!section) return Promise.resolve(false);
    options = options || {};
    var id = section.getAttribute('data-section-id');
    if (!id) return Promise.resolve(false);
    var destinationUrl = new URL(destination, window.location.href);
    // Keep unpublished theme previews on the same theme across filter requests.
    var currentUrl = new URL(window.location.href);
    ['preview_theme_id', '_fd', 'pb'].forEach(function (key) {
      if (currentUrl.searchParams.has(key) && !destinationUrl.searchParams.has(key)) {
        destinationUrl.searchParams.set(key, currentUrl.searchParams.get(key));
      }
    });
    destinationUrl.searchParams.delete('section_id');
    var current = requests.get(id);
    if (current && current.controller) current.controller.abort();
    var task = { controller: window.AbortController ? new AbortController() : null };
    requests.set(id, task);
    section.setAttribute('aria-busy', 'true');

    var opened = section.querySelector('.collection-filter-list > details[open]');
    var openIndex = opened && opened.getAttribute('data-filter-index');
    var requestUrl = new URL(destinationUrl.href);
    requestUrl.searchParams.delete('sections');
    requestUrl.searchParams.set('section_id', id);
    var fetchOptions = { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } };
    if (task.controller) fetchOptions.signal = task.controller.signal;

    return fetch(requestUrl.href, fetchOptions).then(function (response) {
      if (!response.ok) throw new Error('Collection section request failed');
      return response.text();
    }).then(function (html) {
      if (requests.get(id) !== task) return false;
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var replacement = parsed.querySelector('[data-collection-section]');
      if (!replacement || replacement.getAttribute('data-section-id') !== id) {
        throw new Error('The collection results were not returned');
      }
      if (openIndex !== null) {
        var panels = replacement.querySelectorAll('.collection-filter-list > details');
        Array.from(panels).forEach(function (panel) {
          if (panel.getAttribute('data-filter-index') === openIndex) panel.open = true;
        });
      }
      section.replaceWith(replacement);
      if (options.push && destinationUrl.href !== window.location.href) {
        window.history.pushState({ clyroCollection: true }, '', destinationUrl.href);
      }
      restoreFocus(replacement, options.focus);
      var status = replacement.querySelector('[data-collection-status]');
      if (status) status.textContent = 'Products updated.';
      if (options.scroll) {
        var toolbar = replacement.querySelector('.collection-toolbar') || replacement;
        toolbar.scrollIntoView({ block: 'start' });
      }
      document.dispatchEvent(new CustomEvent('collection:updated', { detail: { sectionId: id } }));
      return true;
    }).catch(function (error) {
      if (requests.get(id) !== task || (error && error.name === 'AbortError')) return false;
      // The real collection URL is the progressive enhancement fallback.
      // An API or app failure must never leave a blank or unresponsive grid.
      var message = section.querySelector('[data-collection-error]');
      if (!message) {
        message = document.createElement('p'); message.setAttribute('data-collection-error', '');
        message.setAttribute('role', 'alert');
        var toolbar = section.querySelector('.collection-toolbar') || section;
        toolbar.appendChild(message);
      }
      message.textContent = 'Products could not be updated. Try Apply again, or ';
      var fallback = document.createElement('a');
      fallback.href = destinationUrl.href; fallback.textContent = 'open these results';
      fallback.style.textDecoration = 'underline'; message.appendChild(fallback);
      return false;
    }).finally(function () {
      if (requests.get(id) !== task) return;
      requests.delete(id);
      var active = document.querySelector('[data-collection-section]');
      if (active && active.getAttribute('data-section-id') === id) active.setAttribute('aria-busy', 'false');
    });
  }

  function submit(form, focus) {
    var timer = priceTimers.get(form);
    if (timer) window.clearTimeout(timer);
    priceTimers.delete(form);
    var section = sectionFor(form);
    if (!section || !window.fetch || !window.DOMParser || !window.URL || !window.FormData) return;
    var destination = formDestination(form);
    if (destination.origin !== window.location.origin) return;
    return render(section, destination.href, { push: true, focus: focus });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest && event.target.closest('[data-collection-filter-form]');
    if (!form || !sectionFor(form) || !window.fetch || !window.DOMParser || !window.URL || !window.FormData) return;
    event.preventDefault();
    submit(form, rememberFocus(document.activeElement));
  });

  document.addEventListener('change', function (event) {
    var control = event.target;
    var form = control.closest && control.closest('[data-collection-filter-form]');
    if (!form || !control.name) return;
    var timer = priceTimers.get(form);
    if (timer) window.clearTimeout(timer);
    submit(form, rememberFocus(control));
  });

  document.addEventListener('input', function (event) {
    var control = event.target;
    if (!control.matches || !control.matches('[data-collection-price]')) return;
    var form = control.closest('[data-collection-filter-form]');
    if (!form) return;
    var previous = priceTimers.get(form);
    if (previous) window.clearTimeout(previous);
    priceTimers.set(form, window.setTimeout(function () {
      priceTimers.delete(form);
      submit(form, rememberFocus(control));
    }, 450));
  });

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('.collection-active-filters a, .collection-pagination a');
    if (!link || !sectionFor(link) || event.button !== 0 || event.metaKey || event.ctrlKey ||
        event.shiftKey || event.altKey || link.target || link.hasAttribute('download') ||
        !window.fetch || !window.DOMParser || !window.URL) return;
    var destination = new URL(link.href, window.location.href);
    if (destination.origin !== window.location.origin) return;
    event.preventDefault();
    render(sectionFor(link), destination.href, { push: true, scroll: !!link.closest('.collection-pagination') });
  });

  window.addEventListener('popstate', function () {
    var section = document.querySelector('[data-collection-section]');
    if (section && window.fetch && window.DOMParser) render(section, window.location.href);
  });
})();
